<template>
  <div class="course_page flex-col">
    <!-- PPT播放容器 -->
    <div
      v-if="showPptViewer"
      class="ppt_viewer flex-col flex-center"
    >
      <button
        @click="exitFullscreen"
        class="ppt_close_button"
      >
        关闭（X）
      </button>
      <div
        v-if="isLoading"
        class="loading_indicator"
      >
        <div>加载中...</div>
      </div>
      <iframe
        ref="pptViewerRef"
        :src="pptViewerUrl"
        class="ppt_iframe"
        allowfullscreen
        frameborder="0"
        @load="enterFullscreen"
        @error="handlePptError"
      ></iframe>
    </div>

    <div class="course_header flex-row">
      <BackButton :customClick="handleBackClick" />
      <div class="course_title">{{ courseName }}</div>
    </div>

    <div class="course_list_container flex-col justify-between">
      <div class="course_list_header flex-row">
        <span class="course_count">{{ count }}个课堂</span>
        <!-- <img
          class="pagination_icon"
          referrerpolicy="no-referrer"
          src="../../assets/public/FigmaDDSSlicePNGd4c8b146c5e977ba18d058cd878be396.png"
        />
        <span class="pagination_text">第1/1页</span>
        <img
          class="pagination_next_icon"
          referrerpolicy="no-referrer"
          src="../../assets/public/FigmaDDSSlicePNG909fa7b2d82f34f9422697337d76c62a.png"
        /> -->
      </div>
      <div class="course_table flex-col">
        <div class="course_table_header flex-col">
          <div class="flex-row">
            <span class="header_class">课堂</span>
            <span class="header_name">名称</span>
            <span class="header_tasks">任务数</span>
            <span class="header_ppt">PPT</span>
          </div>
          <div class="header_divider flex-col">
            <div class="divider_line"></div>
          </div>
        </div>
        <div
          class="course_row flex-row"
          v-for="(item, index) in lists"
          :class="index % 2 === 0 ? 'alternate_row_bg' : ''"
        >
          <div
            class="course_row_info flex-row"
            @click="toRecords(item)"
          >
            <span class="course_index">{{ item.serial_no }}</span>
            <span class="course_name">{{ item.lesson_name }}</span>
            <span class="task_count">{{ item.task_count }}</span>
          </div>
          <img
            class="ppt_icon"
            referrerpolicy="no-referrer"
            src="../../assets/teacher/course/FigmaDDSSlicePNG5cd0c64e8786bbeca600b0dbc324f4b9.png"
            @click="playPpt(item.url)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"

import alovaInstance from "@/utils/alova"
import BackButton from "@/components/teacher/BackButton.vue"

const store = useStore()
const route = useRoute()
const router = useRouter()

const showPptViewer = ref(false)
const pptViewerUrl = ref("")
const isLoading = ref(false)
const pptViewerRef = ref(null)

const courseName = ref("课程")
const count = ref(0)

const playPpt = (url) => {
  if (url) {
    // 使用Office Online Viewer预览PPT
    isLoading.value = true
    showPptViewer.value = true
    pptViewerUrl.value = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
      url
    )}`
  } else {
    alert("请提供有效的PPT链接")
  }
}

// 全屏控制函数
const enterFullscreen = () => {
  isLoading.value = false
  const viewer = pptViewerRef.value
  if (!viewer) return
  if (viewer.requestFullscreen) {
    viewer.requestFullscreen()
  } else if (viewer.mozRequestFullScreen) {
    viewer.mozRequestFullScreen()
  } else if (viewer.webkitRequestFullscreen) {
    viewer.webkitRequestFullscreen()
  } else if (viewer.msRequestFullscreen) {
    viewer.msRequestFullscreen()
  }
}

const exitFullscreen = () => {
  showPptViewer.value = false
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

const handlePptError = () => {
  alert("PPT加载失败，请检查链接是否有效")
  exitFullscreen()
}

// 监听全屏状态变化
const handleFullscreenChange = () => {
  if (!document.fullscreenElement) {
    showPptViewer.value = false
  }
}

onMounted(async () => {
  try {
    let id = route.query.courseId
    if (!route.query || !id) {
      alert("缺少课程ID")
      lists.value = []
      count.value = 0
      return
    }
    courseName.value = store.getters.getCourseName(id) || "课程"

    let response = await alovaInstance.Post("/Lesson/GetLessonsByCourseId", {
      courseId: id,
    })
    // console.log(response)
    if (response.code === 1000) {
      lists.value = response.data
      // lists.value = lists.value.concat(lists.value).concat(lists.value)
      count.value = response.data.length
    } else {
      alert("获取信息失败")
    }
  } catch (error) {
    console.error("获取失败:", error)
    alert("获取失败，请稍后重试")
  }
  document.addEventListener("fullscreenchange", handleFullscreenChange)
})

onUnmounted(() => {
  document.removeEventListener("fullscreenchange", handleFullscreenChange)
})

// const lists = ref([
//   {
//     idx: 1,
//     lessonName: "课堂1：人工智能无处不在",
//     counts: 2,
//     lessonId: 1,
//     url: "https://yzm-images.oss-cn-beijing.aliyuncs.com/aifile/1.%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E6%97%A0%E5%A4%84%E4%B8%8D%E5%9C%A8%EF%BC%88%E7%81%B5%E6%99%BA%E9%B8%9F%EF%BC%89.pptx",
//   },
// ])
const lists = ref([])

const toRecords = (item) => {
  // console.log(item)
  store.dispatch("setLessonId", item.id)
  store.dispatch(
    "setLessonName",
    "课堂" + item.serial_no + "：" + item.lesson_name
  )
  store.dispatch("setLessonUrl", item.url)
  router.push({
    path: "/teacher/records",
    query: { lessonId: item.id },
  })
}

const handleBackClick = () => {
  router.push({
    name: "TeacherCourses",
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.course_page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: auto;
  overflow-x: hidden;
}

.course_header {
  margin: 0.6vw 0 0 1.25vw;
}

.course_title {
  width: 74vw;
  height: 1.52vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.14vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.15vw;
  margin: 0.26vw 0 0 0vw;
}

.course_list_container {
  margin: 0.5vw 0 0 1.25vw;
}

.course_list_header {
  width: 79.12vw;
  height: 1.36vw;
}

.course_count {
  width: 4.38vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.36vw;
}

.pagination_icon {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0 0 0 69.32vw;
  cursor: pointer;
}

.pagination_text {
  width: 3.81vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 0.4vw;
  margin-top: 0.1vw;
}

.course_table {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  position: relative;
  width: 80.68vw;
  height: auto;
  min-height: 38.5vw;
  margin-top: 0.68vw;
  margin-bottom: 0.5vw;
  padding-bottom: 16px;
}

.course_table_header {
  width: 69.07vw;
  height: 2.24vw;
  margin: 1.51vw 0 0 6.77vw;
  background-color: transparent;
}

.table_header {
  width: 69.07vw;
  height: 2.24vw;
  margin: 1.51vw 0 0 6.77vw;
}

.header_class {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.header_name {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 11.36vw;
}

.header_tasks {
  width: 3.13vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 40.95vw;
}

.header_divider {
  height: 1.05vw;
  background-size: 1.09vw 1.09vw;
  width: 1.05vw;
  margin: 0;
}

.divider_line {
  background-color: rgba(217, 217, 217, 1);
  width: 80.68vw;
  height: 0.11vw;
  margin: 0.8vw 0 0 -6.75vw;
}

.header_ppt {
  width: 1.88vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 7.4vw;
}

.alternate_row_bg {
  background-color: rgba(247, 251, 255, 1);
}

.course_row_info {
  cursor: pointer;
}

.course_index {
  width: 0.58vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.52vw 0 0 6.77vw;
}

.course_name {
  width: 9.95vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.52vw 0 0 12.86vw;
}

.task_count {
  width: 0.58vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.52vw 0 0 33.43vw;
}

.ppt_icon {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.41vw 5.05vw 0 9.79vw;
  cursor: pointer;
}

.course_row {
  width: 80.68vw;
  height: 2.5vw;
}

.course_row:hover {
  background-color: rgba(205, 230, 255, 1);
}

.pagination_next_icon {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0 0 0 0.05vw;
  cursor: pointer;
}

.ppt_viewer {
  position: relative;
}

.ppt_close_button {
  position: relative;
  width: auto;
  height: auto;
}

.loading_indicator {
  position: relative;
  width: auto;
  height: auto;
  text-align: center;
}

.ppt_iframe {
  position: relative;
  width: auto;
  height: auto;
  border: 0;
}
</style>
